// `GET /staff/me` — the logged-in actor's CURRENT identity + scope.
// The login response snapshots role/teamIds/departmentId into cookies;
// AuthContext refreshes from this endpoint on load so a team/department
// granted mid-session reaches the UI without re-login (2026-07-28).

import { getApiClient } from "./client";

export interface MeResponse {
  username: string;
  role: string;
  teamIds: string[];
  departmentId: string | null;
}

export async function getMe(): Promise<MeResponse> {
  const { data } = await getApiClient().get<MeResponse>("/staff/me");
  return data;
}
